import { get, post } from './common'
type ApiBaseResult = ApiTypes.ApiBaseResult

type TranslateWordType = 'word' | 'paragraph'

interface TranslateResult {
  errMsg: string | null
  wordType: TranslateWordType
  data: {
    // 翻译结果
    transList: Array<string>
    // 音标
    phonetic?: string
    // 词性
    classes?: string
  }
  translateRecordId: number
}

export interface OnlineTranslateOptions {
  text: string
  fromLang: string
  toLang: string
  useType: 'online'
}

export namespace onlineTranslate {

  export function scribeTranslate(
    params: PostDataTypes.ScribeTranslateOptions
  ): Promise<ApiBaseResult & { data: ServerDataTypes.ScribeTranslateResult }> {
    return post('/scribe/translate_v2', {}, { ...params, isDecr: true })
  }

  export function textTranslate(
    params: {
      text: string
      fromLang: string
      toLang: string
      translateModel: string
      useType?: PostDataTypes.UseType | 'compare' | 'select_compare' | 'pdf_compare' | 'text_compare'
    },
    controller?: AbortController
  ): Promise<
    ApiBaseResult & {
      content: string
    }
  > {
    return post('/online/translate', {}, params, undefined, controller)
  }

  export function getDictSearch(
    params: {
      q: string
      cc: string
    }
  ): Promise<ApiBaseResult & { data: any }> {
    return get('/dict/search', params)
  }
}
